import { render, staticRenderFns } from "./ServiciosBarragan.vue?vue&type=template&id=92d39c24&scoped=true&"
import script from "./ServiciosBarragan.vue?vue&type=script&lang=js&"
export * from "./ServiciosBarragan.vue?vue&type=script&lang=js&"
import style0 from "./ServiciosBarragan.vue?vue&type=style&index=0&id=92d39c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d39c24",
  null
  
)

export default component.exports